module.exports = __webpack_public_path__ + "media/mypage/images/ads_banner_125x125-6ad25439c4d52d580d540960c4aa0f57.jpg";